import { ref } from 'vue';
import ImageUtil from '@blade/common/utils/image-util';
import { getSnapImageListByImage, detectTypes } from '@blade-sxp/monitoring-center/api/index';
import { formatSnapImageList } from '@blade-sxp/monitoring-center/utils';
import colors from '@/styles/color.scss';
export const useRecordList = (query) => {
    const snapImageList = ref([]);
    const { image } = query;
    const loading = ref(false);
    const form = ref({
        snapDates: [],
        deviceIdList: [],
        similarity: 95,
        groupTime: 10,
        size: 20,
        page: 1,
    });
    let rawSnapImageList = []; // 接口返回的数据
    const pagination = ref({
        pages: [10, 20, 50, 100],
        total: 0,
    });
    let getImage;
    const activeBorderColor = colors.borderItemHover;
    const privacyMode = localStorage.getItem('privacyMode') || 'false';
    const setPrivacyMode = privacyMode === 'true' ? 6 : 0;
    const updateData = async (recordForm) => {
        if (recordForm) {
            form.value = recordForm;
            form.value.page = 1;
        }
        if (!getImage) {
            getImage = await getFeatureList(image);
        }
        const { featureList, base64Image: imageUrl } = getImage;
        const { snapDates, groupTime, similarity, ...other } = form.value;
        const [dateStart, dateEnd] = snapDates;
        getSnapImageListByImage({
            ...other,
            dateStart,
            dateEnd,
            imageSearchRequest: {
                threshold: similarity / 100,
                imageUrl: imageUrl,
                featureList: featureList,
            },
        }).then((res) => {
            let list = [];
            let total = 0;
            res.searchList.forEach((item) => {
                if (item.list) {
                    list = list.concat(item.list);
                    total += item.total;
                }
            });
            rawSnapImageList = list;
            snapImageList.value = formatSnapImageList(list, groupTime);
            pagination.value.total = total;
        });
    };
    const groupTimeChange = (recordForm) => {
        form.value = recordForm;
        const { groupTime } = recordForm;
        loading.value = true;
        snapImageList.value = formatSnapImageList(rawSnapImageList, groupTime);
        loading.value = false;
    };
    const handleSizeChange = (val) => {
        form.value.size = val;
        form.value.page = 1;
        updateData();
    };
    const handleCurrentChange = (val) => {
        form.value.page = val;
        updateData();
    };
    const getSimilarity = (similarity) => {
        return `${(similarity * 100).toFixed(2)}% `;
    };
    const viewDetails = (val, imgIdx, groupIdx, list) => { };
    return {
        updateData,
        groupTimeChange,
        handleSizeChange,
        handleCurrentChange,
        getSimilarity,
        viewDetails,
        snapImageList,
        loading,
        pagination,
        form,
        activeBorderColor,
        setPrivacyMode,
    };
};
const getFeatureList = (image) => {
    const canvas = document.createElement('canvas');
    return ImageUtil.drawImage(image, canvas).then(() => {
        const base64Image = canvas.toDataURL();
        return detectTypes({ base64Image }).then((data) => {
            let featureList = [];
            data.forEach((item) => {
                if (item.featureList) {
                    featureList = featureList.concat(item.featureList.map((feature) => {
                        return {
                            ...feature,
                            imageUrl: '',
                        };
                    }));
                }
            });
            if (!featureList || !featureList.length) {
                // this.$message.error(`${this.$t('errMsg')}`); // TODO:
                // throw '没有识别到人脸人体';
            }
            else {
                return {
                    featureList,
                    base64Image,
                };
            }
        });
    });
};
